import React from 'react'
import StepNavItem from './StepNavItem'

interface IStep {
  title: string
  onClick: () => void
  active: boolean
  disabled: boolean
}

interface IStepNavProps {
  steps: IStep[]
}

const StepNav = ({ steps }: IStepNavProps) => {
  return (
    <div
      className="sticky-top top-0 d-flex justify-content-between w-full"
      style={{
        backgroundColor: '#F2F5F9',
        height: 54,
        paddingLeft: '15%',
        paddingRight: '15%'
      }}
    >
      {steps.map(({ title, onClick, active, disabled }, index) => {
        return (
          <React.Fragment key={title}>
            <StepNavItem
              title={title}
              stepNumber={index + 1}
              active={active}
              onClick={onClick}
              disabled={disabled}
            />
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default StepNav
